import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DynamicTitleAndFavicon from "./Components/dynamicTitle";
import Home from "./Components/Home";
import HotelsList from "./Components/HotelsList";
import HotelDetails from "./Components/HotelDetails";
import BookingDetailsOne from "./Components/BookingDetailsOne";
import BookingDetailsTwo from "./Components/BookingDetailsTwo";
// import HotelBookingConfirmed from './Components/HotelBookingConfirmed';
import FlightList from "./Components/FlightList";
import FlightReservationOne from "./Components/FlightReservationOne";
import FlightReservationTwo from "./Components/FlightReservationTwo";
import FlightResDigitalTicket from "./Components/FlightResDigitalTicket";
import ManageBooking from "./Components/ManageBooking";
import ManageBookingCancel from "./Components/ManageBookingCancel";
import DepartureReturnFlighs from "./Components/DepartureReturnFlighs";
import TwoWayFlights from "./Components/TwoWayFlights";
import FlightsPay from "./Components/FlightsPay";
import BookingConfirmation from "./Components/BookingConfirmation";
import ErrorPage from "./Components/ErrorPage";
import HotelBookingPay from "./Components/HotelBookingPay";
import EnterVerificationCode from "./Components/EnterVerificationCode";
import DepartureFlights from "./Components/DepartureFlights";
import Usa from "./Components/blogs/Usa";
import Turkey from "./Components/blogs/Turkey";
import Thailand from "./Components/blogs/Thailand";
import Japan from "./Components/blogs/Japan";
import Italy from "./Components/blogs/Italy";
import Indonesia from "./Components/blogs/Indonesia";
import France from "./Components/blogs/France";
import AboutUs from "./Components/AboutUs";
import ContactUs from "./Components/ContactUs";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import RoundFlight from "./Components/RoundFlight";
import Blogs from "./Components/Blog";
import SouthAmerica from "./Components/blogs/SouthAmerica";
import Russia from "./Components/blogs/Russia";
import NorthAmerica from "./Components/blogs/NorthAmerica";
import EastAsia from "./Components/blogs/EastAsia";
import Africa from "./Components/blogs/Africa";
import CancellationPolicy from "./Components/CancellationPolicy";
import NoFlights from "./Components/NoFlights";
import ComingSoon from "./Components/ComingSoon";
import TopTenTipsBookingFlights from "./Components/blogs/Top-10-Tips-for-Booking-Cheap-Flights-Online-in-2025";
import PerfectEuropeanVacationOnBudget from "./Components/blogs/How-to-Plan-Your-Perfect-European-Vacation-on-a-Budget-in-2025";
import EssentialTravelChecklistInternationalTrips from "./Components/blogs/Essential-Travel-Checklist-What-to-Pack-for-International-Trips-in-2025";
import AvoidHiddenFeesWhenBookingFlightsHotels from "./Components/blogs/How-to-Avoid-Hidden-Fees-When-Booking-Flights-and-Hotels-in-2025";
import UltimateGuideBookingLastMinuteFlights from "./Components/blogs/The-Ultimate-Guide-to-Booking-Last-Minute-Flights-in-2025";
import TopTenCheapestCountries from "./Components/blogs/Top-10-Cheapest-Countries-to-Visit-in-2026";
import BookInternationalFlightsFaster from "./Components/blogs/How-to-Book-International-Flights-Faster-Without-Compromising-on-Price";
import DirectVsConnectingFlights from "./Components/blogs/Direct-vs-Connecting-Flights-Which-One-Should-You-Choose";
function App() {
  return (
    <>
      <DynamicTitleAndFavicon />
      <Routes>
        <Route path="/" element={<Home />} exact></Route>
        <Route path="/HotelsList" element={<HotelsList />} exact></Route>
        <Route path="/HotelDetails" element={<HotelDetails />} exact></Route>
        <Route
          path="/BookingDetailsOne"
          element={<BookingDetailsOne />}
          exact
        ></Route>
        <Route
          path="/BookingDetailsTwo"
          element={<BookingDetailsTwo />}
          exact
        ></Route>
        {/* <Route path="HotelBookingConfirmed" element={<HotelBookingConfirmed />} exact></Route> */}
        <Route path="/FlightList" element={<FlightList />} exact></Route>
        <Route
          path="/FlightReservationOne"
          element={<FlightReservationOne />}
          exact
        ></Route>
        <Route
          path="/FlightReservationTwo"
          element={<FlightReservationTwo />}
          exact
        ></Route>
        <Route
          path="/FlightDigitalTicket"
          element={<FlightResDigitalTicket />}
          exact
        ></Route>
        <Route path="/ManageBooking" element={<ManageBooking />} exact></Route>
        <Route
          path="/ManageBookingCancel"
          element={<ManageBookingCancel />}
          exact
        ></Route>
        <Route
          path="/DepartureReturnFlighs"
          element={<DepartureReturnFlighs />}
          exact
        ></Route>
        <Route path="/TwoWayFlights" element={<TwoWayFlights />} exact></Route>
        <Route path="/FlightsPay" element={<FlightsPay />} exact></Route>
        <Route
          path="/BookingConfirmation"
          element={<BookingConfirmation />}
          exact
        ></Route>
        <Route path="/ErrorPage" element={<ErrorPage />} exact></Route>
        <Route
          path="/HotelBookingPay"
          element={<HotelBookingPay />}
          exact
        ></Route>
        <Route
          path="/EnterVerificationCode"
          element={<EnterVerificationCode />}
          exact
        ></Route>
        <Route
          path="/DepartureFlights"
          element={<DepartureFlights />}
          exact
        ></Route>
        <Route path="/Blogs" element={<Blogs />} exact></Route>
        <Route path="/Usa" element={<Usa />} exact></Route>
        <Route path="/Turkey" element={<Turkey />} exact></Route>
        <Route path="/Thailand" element={<Thailand />} exact></Route>
        <Route path="/Japan" element={<Japan />} exact></Route>
        <Route path="/Italy" element={<Italy />} exact></Route>
        <Route path="/Indonesia" element={<Indonesia />} exact></Route>
        <Route path="/France" element={<France />} exact></Route>
        <Route path="/SouthAmerica" element={<SouthAmerica />} exact></Route>
        <Route path="/Russia" element={<Russia />} exact></Route>
        <Route path="/NorthAmerica" element={<NorthAmerica />} exact></Route>
        <Route path="/EastAsia" element={<EastAsia />} exact></Route>
        <Route path="/Africa" element={<Africa />} exact></Route>
        <Route path="/AboutUs" element={<AboutUs />} exact></Route>
        <Route path="/ContactUs" element={<ContactUs />} exact></Route>
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} exact></Route>
        <Route path="/RoundFlight" element={<RoundFlight />} exact></Route>
        <Route path="/ComingSoon" element={<ComingSoon />} exact></Route>
        <Route
          path="/CancellationPolicy"
          element={<CancellationPolicy />}
          exact
        ></Route>
        <Route path="/NoFlights" element={<NoFlights />} exact />
        <Route
          path="/TopTenTipsBookingFlights"
          element={<TopTenTipsBookingFlights />}
          exact
        />
        <Route
          path="/PerfectEuropeanVacationOnBudget"
          element={<PerfectEuropeanVacationOnBudget />}
          exact
        />
        <Route
          path="/EssentialTravelChecklistInternationalTrips"
          element={<EssentialTravelChecklistInternationalTrips />}
          exact
        />
        <Route
          path="/AvoidHiddenFeesWhenBookingFlightsHotels"
          element={<AvoidHiddenFeesWhenBookingFlightsHotels />}
          exact
        />
        <Route
          path="/UltimateGuideBookingLastMinuteFlights"
          element={<UltimateGuideBookingLastMinuteFlights />}
          exact
        />
        <Route
          path="/TopTenCheapestCountries"
          element={<TopTenCheapestCountries />}
          exact
        />
        <Route
          path="/BookInternationalFlightsFaster"
          element={<BookInternationalFlightsFaster />}
          exact
        />
        <Route
          path="/DirectVsConnectingFlights"
          element={<DirectVsConnectingFlights />}
          exact
        />
      </Routes>
    </>
  );
}

export default App;
